import styles from 'components/icons/Icon.module.scss';
import { IconProps } from 'components/icons/Icons.types';
import React from 'react';

const BoyIcon: React.FC<IconProps> = ({
  className = '',
  size = 24,
  color = '#fffff0',
  fillColor = 'transparent',
  fillOpacity = 1,
  circleStrokeColor = 'transparent',
}) => {
  const baseCls = `${styles.IconContainer} ${className}`;
  return (
    <div className={baseCls}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="transparent" xmlns="http://www.w3.org/2000/svg">
        <circle
          fill={fillColor}
          fillOpacity={fillOpacity}
          cx="12"
          cy="12"
          r="10.5"
          stroke={circleStrokeColor}
          strokeWidth={'1.5px'}
        />
        <path
          d="M9 14C9.55228 14 10 13.5523 10 13C10 12.4477 9.55228 12 9 12C8.44771 12 8 12.4477 8 13C8 13.5523 8.44771 14 9 14Z"
          fill={color}
        />
        <path
          d="M16 13C16 13.5523 15.5523 14 15 14C14.4477 14 14 13.5523 14 13C14 12.4477 14.4477 12 15 12C15.5523 12 16 12.4477 16 13Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 11.1637 19.8717 10.3574 19.6337 9.59973C18.7991 9.82556 17.9212 9.94604 17.0152 9.94604C13.2921 9.94604 10.0442 7.91139 8.32277 4.89334C5.75469 6.22486 4 8.90751 4 12C4 16.4183 7.58172 20 12 20Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default BoyIcon;
